import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { useTranslation } from 'react-i18next';
import { CabinetFurniturePage } from './CabinetFurniturePage';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectFurniture } from '../Configurator/selectors/furniture';
import { Furniture } from '../../lib/modelBuilder/entities/Furniture';
import { RootState } from '../App/types';
import './print.css';
import { FurnitureEditorContext } from '../../lib/constraintsChecker/FurnitureEditor';
import { makeSelectContext } from '../Configurator/selectors/general';

class ComponentToPrint extends React.Component<{
  t: any;
  furniture: Furniture;
  context: FurnitureEditorContext;
}> {
  render() {
    const { t, furniture, context } = this.props;
    return (
      furniture && (
        <div>
          {furniture.quantity > 1 ? (
            <CabinetFurniturePage
              cabinetOrFurniture={furniture}
              t={t}
              pageBreakBefore={false}
              context={context}
            />
          ) : null}
          {furniture.cabinets.map((cabinetEntry: any, index: number) => (
            <CabinetFurniturePage
              key={cabinetEntry.cabinet.id}
              cabinetOrFurniture={cabinetEntry.cabinet}
              t={t}
              pageBreakBefore={furniture.quantity > 1}
              context={context}
            />
          ))}
        </div>
      )
    );
  }
}

interface StateProps {
  furniture: Furniture | null;
  context: FurnitureEditorContext;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  furniture: makeSelectFurniture(),
  context: makeSelectContext(),
});

export function Printer() {
  const { t } = useTranslation();
  const componentRef = useRef<any>(null);
  const { furniture, context } = useSelector(stateSelector);

  return furniture && furniture.quantity > 0 ? (
    <div>
      <ReactToPrint
        trigger={() => (
          // Need to use ref to hide/display loading because of react-to-print limitation
          // react-to-print REQUIRES one and only one button at each time, to set their onClick
          <button id="reacttoprint" className="sethidden">
            {t('Print')}
          </button>
        )}
        content={() => componentRef.current}
        bodyClass="toprint"
        onBeforePrint={() => {
          // Content is now prepared, we must flush existing content
          // Useful in case of reprint and if an error occurs, to avoid to
          // print the previous content
        }}
        onAfterPrint={() => {
          // After print means after print has been proposed to user
          // So, good time to end loader and display again button content
        }}
      />
      <div className="will-print" style={{ display: 'none' }}>
        <ComponentToPrint
          ref={componentRef}
          furniture={furniture}
          t={t}
          context={context}
        />
      </div>
    </div>
  ) : (
    <div></div>
  );
}
